<mat-checkbox
  color="primary"
  [(ngModel)]="value"
  (change)="change.emit($event)"
  [disabled]="disabled"
  [checked]="checked"
  >{{ label }}</mat-checkbox
>
